import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const OntchromenPage = () => {
  return <main data-id="element-1156" data-mp="31t11f7nsnsey">
      <SEO title="Auto Ontchromen Almere | Chrome Delete | BKCustoms" description="Professioneel auto ontchromen in Almere vanaf €75. Chrome delete voor een moderne, strakke look. Niet-permanente modificatie met hoogwaardige vinyl bij BKCustoms." canonical="/diensten/ontchromen" data-id="element-1157" data-mp="31s7pls9zacpy" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-1158" data-mp="3fqz074pmtg9c">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1159" data-mp="3kjii2dvcqxjy">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-1160" data-mp="3pivdhn0ahcy5"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8h8EqFfY6iTr2pX1pd2aXy/AS_Dechrome_Hero-768x512.jpg" alt="Auto ontchromen in Almere" className="w-full h-full object-cover object-center" data-id="element-1161" data-mp="3pibr9u3lw2eb" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1162" data-mp="2d57qvf2vogwo">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1163" data-mp="292uon0ncb14n">
            <span className="text-[#D6281F]" data-id="element-1164" data-mp="295qlelngbjri">Auto Ontchromen Almere</span> -
            Voor een strakke, moderne look
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg mb-4" data-id="element-1165" data-mp="1z5zqiiuzb2qw">
            Transformeer je auto in Almere met onze professionele ontchroom
            service. Vervang glanzende chrome elementen voor stijlvolle matte of
            glanzende zwarte accenten. Vanaf slechts €75.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-1166" data-mp="2n2dkatyysk02">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1167" data-mp="2i4bzo4lw4cmh">
              <span className="mr-2" data-id="element-1168" data-mp="3arex0tetyhb5">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-1169" data-mp="18uxoiwbbfkun" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1170" data-mp="18xjwgx24c2de">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1171" data-mp="p9jfmah1utmz">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1172" data-mp="u7ckn06m9hlo">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-1173" data-mp="g6ibgfbqvcly">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-1174" data-mp="l53badn33u9v">
              <div className="relative" data-id="element-1175" data-mp="l5v8tu08s22s">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1176" data-mp="2akt0ansca6rq"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1177" data-mp="2fj49cwat8d8w">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8h8EqFfY6iTr2pX1pd2aXy/AS_Dechrome_Hero-768x512.jpg" alt="Auto ontchromen voorbeeld in Almere" className="w-full h-auto object-cover" data-id="element-1178" data-mp="2po2qx1tq10s0" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-1179" data-mp="38crbfmoal439">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1180" data-mp="38fvkaxcpco09">
                Auto Ontchromen Almere - Vanaf €75
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1181" data-mp="3hdpea1mzv5k9">
                Auto ontchromen, ook wel bekend als 'Chrome Delete', is een
                populaire styling techniek waarbij glanzende chrome elementen
                worden vervangen door matte of glanzende zwarte accenten. Dit
                geeft jouw auto een moderne, sportieve en onderscheidende
                uitstraling.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-1182" data-mp="1kg0agdgvnkf8">
                Bij BKCustoms in Almere gebruiken we hoogwaardige wrapping
                materialen om chromen elementen zoals raamlijsten, grilles,
                emblemen en andere accenten te transformeren, zonder de
                originele onderdelen te beschadigen.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1183" data-mp="11qtnufcyq8o5">
                <div className="flex items-center" data-id="element-1184" data-mp="11nz1giae2ds3">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1185" data-mp="15sf6khc6hh69">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1186" data-mp="1apyl7icsfvyq" />
                  </div>
                  <span className="text-white/90" data-id="element-1187" data-mp="1fgx50rwzjc6q">
                    Niet-permanente modificatie
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1188" data-mp="i19ri4e2asx0">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1189" data-mp="n0meqq8ui204">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1190" data-mp="myjd18ybykfk" />
                  </div>
                  <span className="text-white/90" data-id="element-1191" data-mp="ffae69nga44r">
                    Hoogwaardige vinyl materialen
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1192" data-mp="5ifhlwaqmdt4">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1193" data-mp="5la0hje3rqkf">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1194" data-mp="1h2alivws4km" />
                  </div>
                  <span className="text-white/90" data-id="element-1195" data-mp="3soojbpxhix8c">
                    Bescherming van originele onderdelen
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1196" data-mp="3ixtz0r3su7pj">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1197" data-mp="3iymuux17zcsw">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1198" data-mp="3e01xd5dcr785" />
                  </div>
                  <span className="text-white/90" data-id="element-1199" data-mp="39xosej6fjdcf">
                    Keuze uit matte of glanzende afwerking
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1200" data-mp="2vayg6mr640c2">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1201" data-mp="2v9f1h0l5txce">
                  <span className="mr-2" data-id="element-1202" data-mp="2qcesohwxeghl">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-1203" data-mp="3e1g7cmwcqnvb" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1204" data-mp="3e3arw03podyv">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What We Offer Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-1205" data-mp="5lo5w9ai6obe">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1206" data-mp="5nhbrmdal4ic">
          <div className="text-center mb-16" data-id="element-1207" data-mp="1qarvzj0pme7p">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1208" data-mp="1q9grti3cr4g2">
              Auto Ontchromen in <span className="text-[#D6281F]" data-id="element-1209" data-mp="1law0y99zpx4a">Almere</span>
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1210" data-mp="1z3ll085ykryr">
              Bij BKCustoms in Almere kunnen we diverse chrome elementen van je
              auto vervangen door stijlvolle zwarte accenten
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1211" data-mp="12dulfuit8em3">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1212" data-mp="12fp38zysbqly">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1213" data-mp="1gef4mrsn0cg4">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1214" data-mp="1bdhki9o2h8bz" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1215" data-mp="2rrznb042yag4">Raamlijsten</h3>
              <p className="text-white/80" data-id="element-1216" data-mp="2mty4mgakgd56">
                Vervang glanzende chrome raamlijsten door elegante zwarte
                accenten voor een sportieve, moderne uitstraling.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1217" data-mp="3bu3xwjf60z23">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1218" data-mp="3fwqusyqp1a65">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1219" data-mp="3funspgc9nql2" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1220" data-mp="3kpbmnuq1hd71">
                Grilles & Emblemen
              </h3>
              <p className="text-white/80" data-id="element-1221" data-mp="3ulek4n9y4nnn">
                Transformeer je grille en emblemen naar stijlvolle zwarte
                accenten voor een unieke, onderscheidende look.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1222" data-mp="7h75gat58bwd">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1223" data-mp="256gjb2vyl6m1">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1224" data-mp="258jf63jsltyo" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1225" data-mp="298bt6vrygsbf">
                Complete Chrome Delete
              </h3>
              <p className="text-white/80" data-id="element-1226" data-mp="21qdl8vpf9pab">
                Voor maximale impact bieden we een volledige chrome delete voor
                alle chromen elementen op je auto.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-1227" data-mp="1nxo00thpwoe9">
            <p className="text-white/70 text-lg" data-id="element-1228" data-mp="1nyz4ywmwg26y">
              Auto ontchromen in Almere vanaf €75, afhankelijk van het type auto
              en de hoeveelheid chrome elementen.
              <br data-id="element-1229" data-mp="2fplpi30fznld" />
              Neem contact met ons op voor een persoonlijke offerte.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-1230" data-mp="26of69m6eryof">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-1231" data-mp="107jx6occssob">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1232" data-mp="108v0yo5su0ff">
            Klaar voor een moderne look met auto ontchromen in Almere?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-1233" data-mp="3fnepgtxa9awb">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1234" data-mp="3ogrtos0sryxp">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1235" data-mp="3jpjh5n467xgb">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-1236" data-mp="3tet7axfgf61s">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};